export function toInt(obj,defaultValue) {
	if(!obj){
		return defaultValue;
	}
	return parseInt(obj,10);
}

/**
 * @param {Object} obj数值
 * @param {Object} num 保留小数位数
 */
export function toFix(obj,num,defaultValue){
	if(obj){
		obj=parseFloat(obj)
		return obj.toFixed(num)
	}
	if(defaultValue){
		return defaultValue
	}
	return obj
}


// WEBPACK FOOTER //
// ./src/util/Convert.js